import { render, staticRenderFns } from "./CategoryFacetItem.vue?vue&type=template&id=4f3feaf8&scoped=true&name=category-facet-item&"
import script from "./CategoryFacetItem.vue?vue&type=script&lang=js&"
export * from "./CategoryFacetItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFacetItem.vue?vue&type=style&index=0&id=4f3feaf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3feaf8",
  null
  
)

export default component.exports